// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import Iconify from "../../../components/Iconify";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);
const getColorIcon = (icon) => (
  <Iconify icon={icon} sx={{ width: 18, height: 18 }} />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  dashboard: getIcon("ic_dashboard"),
  courier: getIcon("ic_courier"),
  school: getIcon("ic_school"),
  chart: getIcon("ic_pieChart"),
  search: getIcon("ic_search"),
  tuckshop: getIcon("ic_tuckshop"),
  archival: getIcon("ic_archival"),
  master: getIcon("ic_master"),
  parent: getIcon("ic_parent"),
  report: getIcon("ic_report"),
  // ticket: getIcon("ic_bug"),
  orderStatus: getIcon("ic_order_status"),
  ticket: getIcon("ic_ticket"),
};

const getNavConfig = () => {
  const userType = localStorage.getItem("userType");
  // console.log("User Type from localStorage:",  userType);

  const isClient = userType === "CLIENT";
  const isManager = userType === "MANAGER";

  // Manager role: only show Reports (no Dashboard, no Master Module, no QR Codes)
  if (isManager) {
    return [
      {
        subheader: "Reports Module",
        items: [
          {
            title: "Reports",
            path: PATH_DASHBOARD.reports.root,
            icon: ICONS.report,
            defaultOpen: true,
            children: [
              {
                title: "Attendance Report",
                path: PATH_DASHBOARD.reports.attendanceReport,
                icon: getColorIcon("twemoji:alarm-clock"),
              },
              {
                title: "Patrolling Report",
                path: PATH_DASHBOARD.reports.patrollingReport,
                icon: getColorIcon("twemoji:round-pushpin"),
              },
              {
                title: "Master Report",
                path: PATH_DASHBOARD.reports.masterReport,
                icon: getColorIcon("twemoji:books"),
              },
              // {
              //   title: "Live Tracking",
              //   path: PATH_DASHBOARD.reports.liveTracking,
              //   icon: getColorIcon("twemoji:round-pushpin"),
              // },
            ],
          },
        ],
      },
    ];
  }

  return [
    {
      subheader: "general",
      items: [
        {
          title: "Dashboard",
          path: PATH_DASHBOARD.general.app,
          icon: ICONS.dashboard,
        },
      ],
    },
    {
      subheader: "Reports Module",
      items: [
        {
          title: "Reports",
          path: PATH_DASHBOARD.reports.root,
          icon: ICONS.report,
          defaultOpen: true,
          children: [
            {
              title: "Attendance Report",
              path: PATH_DASHBOARD.reports.attendanceReport,
              icon: getColorIcon("twemoji:alarm-clock"),
            },
            {
              title: "Patrolling Report",
              path: PATH_DASHBOARD.reports.patrollingReport,
              icon: getColorIcon("twemoji:round-pushpin"),
            },
            {
              title: "Master Report",
              path: PATH_DASHBOARD.reports.masterReport,
              icon: getColorIcon("twemoji:books"),
            },
            {
              title: "Live Tracking",
              path: PATH_DASHBOARD.reports.liveTracking,
              icon: getColorIcon("twemoji:round-pushpin"),
            },
          ],
        },
      ],
    },
    ...(!isClient
      ? [
          {
            subheader: "Master Module",
            items: [
              {
                title: "Master",
                path: PATH_DASHBOARD.master.root,
                icon: ICONS.master,
                defaultOpen: true,
                children: [
                  {
                    title: "Client",
                    path: PATH_DASHBOARD.master.client,
                    icon: getColorIcon("twemoji:briefcase"),
                  },
                  {
                    title: "Staff",
                    path: PATH_DASHBOARD.master.staff,
                    icon: getColorIcon("twemoji:busts-in-silhouette"),
                  },
                  ...(userType === "COMPANY" || userType === "SUPER_ADMIN"
                    ? [
                        {
                          title: "Staff Documents",
                          path: PATH_DASHBOARD.master.documents,
                          icon: getColorIcon("twemoji:page-facing-up"),
                        },
                      ]
                    : []),
                  {
                    title: "Create QR Code",
                    path: PATH_DASHBOARD.master.clientQrCode,
                    icon: getColorIcon("material-symbols:qr-code-2-rounded"),
                  },
                  {
                    title: "Checklist",
                    path: PATH_DASHBOARD.master.checklist,
                    icon: getColorIcon("twemoji:clipboard"),
                  },
                  ...(userType === "SUPER_ADMIN"
                    ? [
                        {
                          title: "Create Login",
                          path: PATH_DASHBOARD.master.user,
                          icon: getColorIcon("twemoji:person"),
                        },
                      ]
                    : []),
                  ...(userType !== "COMPANY"
                    ? [
                        {
                          title: "Company",
                          path: PATH_DASHBOARD.master.company,
                          icon: getColorIcon("twemoji:office-building"),
                        },
                      ]
                    : []),
                ],
              },
            ],
          },
          {
            subheader: "Settings",
            items: [
              {
                title: "Settings",
                path: PATH_DASHBOARD.master.designation,
                icon: getColorIcon("twemoji:gear"),
                defaultOpen: false,
                children: [
                  {
                    title: "Designation",
                    path: PATH_DASHBOARD.master.designation,
                    icon: getColorIcon("twemoji:label"),
                  },
                  ...(userType === "SUPER_ADMIN" || userType === "COMPANY"
                    ? [
                        {
                          title: "Incident Categories",
                          path: PATH_DASHBOARD.master.incidentCategory,
                          icon: getColorIcon("twemoji:warning"),
                        },
                      ]
                    : []),
                  {
                    title: "Checklist Categories",
                    path: PATH_DASHBOARD.master.checklistCategory,
                    icon: getColorIcon("twemoji:clipboard"),
                  },
                  ...(userType === "COMPANY" || userType === "SUPER_ADMIN"
                    ? [
                        {
                          title: "Document Types",
                          path: PATH_DASHBOARD.master.documentTypes,
                          icon: getColorIcon("twemoji:bookmark-tabs"),
                        },
                      ]
                    : []),
                  {
                    title: "Training Video",
                    path: "https://youtu.be/Vtn2QpqzZUc?si=b9MBLapMABzOWd4i",
                    icon: getColorIcon("twemoji:clapper-board"),
                  },
                  {
                    title: "WhatsApp Support",
                    path: "http://api.whatsapp.com/send/?phone=919372609170&text=Hi+Team+&app_absent=0",
                    icon: getColorIcon("logos:whatsapp-icon"),
                  },
                ],
              },
            ],
          },
        ]
      : []),
  ];
};

export default getNavConfig;
